import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * Logo de tRespondo.cl
 * Isotipo: burbuja de chat estilo WhatsApp con una "t" y doble check azul (mensaje leído).
 */
export const LogoMark: React.FC<{ size?: number; title?: string }> = ({ size = 36, title = 'tRespondo.cl' }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <Box component="svg" viewBox="0 0 64 64" width={size} height={size} role="img" aria-label={title} sx={{ flexShrink: 0, display: 'block' }}>
      <title>{title}</title>
      <defs>
        <linearGradient id={`trg-${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#25D366" />
          <stop offset="1" stopColor="#075E54" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill={`url(#trg-${id})`} />
      {/* Burbuja de chat */}
      <path fill="#ffffff" d="M32 11c-11.6 0-21 8.5-21 19 0 4.7 1.9 9 5 12.3L13.5 52l10.4-3.8c2.5.9 5.2 1.4 8.1 1.4 11.6 0 21-8.5 21-19S43.6 11 32 11Z" />
      {/* Letra t */}
      <path d="M26 19.5v14.5c0 3 1.6 4.5 4.6 4.5M21.5 25h10" fill="none" stroke="#128C7E" strokeWidth="4.4" strokeLinecap="round" strokeLinejoin="round" />
      {/* Doble check (leído) */}
      <path d="M33 33.2l3 3 6-6.8M39.2 36.2l6-6.8" fill="none" stroke="#34B7F1" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
    </Box>
  );
};

interface LogoProps {
  size?: number;
  /** 'dark' para fondos claros, 'light' para fondos oscuros/verdes */
  tone?: 'dark' | 'light';
  showDomain?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 36, tone = 'dark', showDomain = true }) => {
  const main = tone === 'light' ? '#ffffff' : '#0B3B35';
  const accent = tone === 'light' ? '#DCF8C6' : '#25D366';
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ userSelect: 'none' }}>
      <LogoMark size={size} />
      <Typography component="span" sx={{ fontWeight: 800, fontSize: size * 0.56, letterSpacing: '-0.02em', lineHeight: 1, color: main }}>
        <Box component="span" sx={{ color: accent }}>t</Box>Respondo
        {showDomain && <Box component="span" sx={{ color: accent, fontWeight: 700 }}>.cl</Box>}
      </Typography>
    </Stack>
  );
};

export default Logo;
